import React, { useState } from "react";
import {
  Card,
  Table,
  Form,
  Dropdown,
  Row,
  Col
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiEdit, FiTrash2 } from "react-icons/fi";

import "react-datepicker/dist/react-datepicker.css";
import EditLeadModal from "../../../components/modals/leads/edit-leads/EditLeadModal";
import DeleteModal from "../../../components/modals/leads/add-leads/DeleteModal";

import LeadsHeader from "../../../components/crm/leads/LeadsHeader";
import company1 from "../../../assets/img/company/company-01.svg";
import company2 from "../../../assets/img/company/company-02.svg";
import company3 from "../../../assets/img/company/company-03.svg";
import company4 from "../../../assets/img/company/company-04.svg";
import company5 from "../../../assets/img/company/company-05.svg";
import company6 from "../../../assets/img/company/company-06.svg";
import company7 from "../../../assets/img/company/company-07.svg";
import company8 from "../../../assets/img/company/company-08.svg";
import AddLeadModal from "../../../components/modals/leads/add-leads/AddLeadModal";
// import AddContactModal from "../../../components/modals/contacts/add-contacts/AddContactModal";

const LeadsList = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [status, setStatus] = useState("Tags");
  const [sort, setSort] = useState("Sort By : Last 7 Days");
  const [search, setSearch] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [contactShow, setContactShow] = useState(false);

  const data = [
    {
      name: "Hansen",
      company: "Nimbus Networks",
      phone: "(189) 0920 723",
      tag: "Closed",
      tagColor: "success",
      date: "15 Nov 2024",
      owner: "Craig Brown",
      logo:company1
    },
    {
      name: "Wisozk",
      company: "Aurora Technologies",
      phone: "(183) 9302 890",
      tag: "Closed",
      tagColor: "success",
      date: "12 Apr 2024",
      owner: "Smith Cooper",
      logo:company2
    },
    {
      name: "Walter",
      company: "UrbanPulse Design",
      phone: "(162) 8920 713",
      tag: "Closed",
      tagColor: "success",
      date: "02 Sep 2024",
      owner: "Janet Carlson",
      logo:company3
    },
    {
      name: "Heller",
      company: "BlueSky Ventures",
      phone: "(120) 3728 039",
      tag: "Contacted",
      tagColor: "purple",
      date: "20 Apr 2024",
      owner: "Martin Lewis",
      logo: company4
    },
    {
      name: "Leuschke",
      company: "Epicurean Delights",
      phone: "(168) 8392 823",
      tag: "Lost",
      tagColor: "danger",
      date: "10 Dec 2024",
      owner: "Daniel Byrne",
      logo: company5
    },
    {
      name: "Gutkowski",
      company: "TerraFusion Energy",
      phone: "(102) 8480 832",
      tag: "Not Contacted",
      tagColor: "warning",
      date: "06 Jul 2024",
      owner: "Newell Egan",
      logo: company6
    },
    {
      name: "Collins",
      company: "BrightWave Innovations",
      phone: "(123) 4567 890",
      tag: "Closed",
      tagColor: "success",
      date: "14 Jan 2024",
      owner: "Hendry Milner",
      logo:company7
    },
        {
      name: "Collins",
      company: "BrightWave Innovations",
      phone: "(123) 4567 890",
      tag: "Closed",
      tagColor: "success",
      date: "14 Jan 2024",
      owner: "Hendry Milner",
      logo:company8
    }
    
  ];


  return (
    <div style={{ padding: "15px", background: "#f8f9fa" }}>
      
                 <LeadsHeader
             title="Contact Grid"
             openModal={() => setContactShow(true)}
           />
      <Card className="contact-card">
        <Card.Header className="d-flex justify-content-between flex-wrap">
          <h5>Leads List</h5>

          <div className="d-flex flex-wrap gap-2 align-items-center">
            <DatePicker
              selectsRange
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={(update) => setDateRange(update)}
              placeholderText="dd/mm/yyyy - dd/mm/yyyy"
              className="form-control"
            />

            <Dropdown>
              <Dropdown.Toggle className="bg-white text-dark">
                {status}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {["Closed", "Lost", "Contacted"].map((item) => (
                  <Dropdown.Item onClick={() => setStatus(item)}>
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle className="bg-white text-dark">
                {sort}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[
                  "Recently Added",
                  "Ascending",
                  "Descending",
                  "Last Month",
                  "Last 7 Days"
                ].map((item) => (
                  <Dropdown.Item onClick={() => setSort(item)}>
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        <Card.Body>
          {/* Top Controls */}
          <Row className="mb-3">
            <Col md={6}>
              <div className="d-flex align-items-center gap-2">
                <span>Row Per Page</span>
                <Form.Select style={{ width: 80 }}>
                  <option>10</option>
                </Form.Select>
                <span>Entries</span>
              </div>
            </Col>

            <Col md={6} className="text-end">
              <Form.Control
                placeholder="Search"
                style={{ maxWidth: 250, marginLeft: "auto" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
          </Row>

          {/* TABLE */}
          <Table responsive className="contact-table">
            <thead>
              <tr>
                <th><Form.Check /></th>
                <th>Lead Name</th>
                <th>Company Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Tags</th>
                <th>Created Date</th>
                <th>Lead Owner</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, i) => (
                <tr key={i}>
                  <td><Form.Check /></td>
                  <td>{item.name}</td>

                  <td className="d-flex align-items-center gap-2">
                    <img src={item.logo} className="company-logo" />
                    {item.company}
                  </td>

                  <td>{item.phone}</td>
                  <td>[email protected]</td>

                  <td>
                    <span className={`badge custom-badge ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </td>

                  <td>{item.date}</td>
                  <td>{item.owner}</td>

                  <td>
                    <FiEdit onClick={() => setShowEdit(true)} className="action-icon" />
                    <FiTrash2 onClick={() => setShowDelete(true)} className="action-icon" />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <EditLeadModal show={showEdit} onHide={() => setShowEdit(false)} />
      <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} />
<AddLeadModal
  show={contactShow}
  handleClose={() => setContactShow(false)}
/>
{/* <AddContactModal
  show={contactShow}
  handleClose={() => setContactShow(false)}
/> */}
      {/* CSS */}
      <style>{`
        .company-logo {
          width: 28px;
          height: 28px;
          border-radius: 50%;
        }

        .custom-badge {
          padding: 5px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        .success { background: #d1f2e1; color: #1e8449; }
        .purple { background: #e8daef; color: #6c3483; }
        .danger { background: #f5b7b1; color: #922b21; }
        .warning { background: #fdebd0; color: #b9770e; }

        .action-icon {
          margin-right: 10px;
          cursor: pointer;
        }

        @media (max-width: 768px) {
          .contact-table td {
            white-space: nowrap;
          }
        }
      `}</style>
    </div>
  );
};

export default LeadsList;